import React, { useState, useEffect, useLayoutEffect } from 'react';
import { View, ActivityIndicator, StyleSheet, BackHandler } from 'react-native';
import { useDispatch } from 'react-redux';
import { getTripConfirmation } from '../store/actions/payment';
import { CommonProperties, CommonStyles, Color } from '../styles';
import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';
import { Screens } from '../constants/ScreenNames';
import { goHomeLeftHeaderOption } from '../utils/defaultNavOptions';
import InvoiceSummary from '../components/TripInvoice/InvoiceSummary';
import BottomButton from '../components/BottomButton';
import WrapBottomColor from '../components/containers/WrapBottomColor';
import { EVENTS_ENABLED, REBOOK_ENABLED } from '../config/env';

const ReceiptScreen = ({ route, navigation }) => {
  const { t } = useTranslation(i18nNS.myTrips);
  const { tKey } = useComponentTKey('ReceiptScreen');
  const dispatch = useDispatch();
  const { tripKey, returnScreen } = route.params || {};
  const [receiptLoading, setReceiptLoading] = useState(false);

  useEffect(() => {
    async function fetchrePrice() {
      setReceiptLoading(true);
      await dispatch(getTripConfirmation(tripKey, route.params?.travelRequestId));
      setReceiptLoading(false);
    }
    fetchrePrice();
  }, [dispatch, tripKey]);
  useLayoutEffect(() => {
    function handleBackButton() {
      navigation.navigate(
        REBOOK_ENABLED ? Screens.RebookHome : EVENTS_ENABLED ? Screens.EventHome : Screens.Home
      );
      return true;
    }
    if (returnScreen !== Screens.MyTrips) {
      navigation.setOptions({
        ...goHomeLeftHeaderOption(navigation),
      });
    }
    BackHandler.addEventListener('hardwareBackPress', handleBackButton);
    return () => BackHandler.removeEventListener('hardwareBackPress', handleBackButton);
  }, [returnScreen, navigation]);

  return (
    <WrapBottomColor style={CommonStyles.flex1}>
      {receiptLoading ? (
        <View style={styles.activity}>
          <ActivityIndicator size="small" />
        </View>
      ) : (
        <>
          <InvoiceSummary />

          <BottomButton
            label={t(tKey('GoHome'))}
            full
            onPress={() => navigation.navigate(REBOOK_ENABLED ? Screens.RebookHome : Screens.Home)}
          />
        </>
      )}
    </WrapBottomColor>
  );
};

const styles = StyleSheet.create({
  activity: {
    flex: 1,
    backgroundColor: Color.accent,
    ...CommonProperties.mt3,
  },
});

export default ReceiptScreen;
